import { Controller } from 'react-hook-form';
import { ButtonSecondary, ButtonType, Checkbox } from '@ui/src';
import { RiskScoreCalculationType } from '../../hoc/types';
import { CalculateFormTypes } from './types';

import cn from './calculate-form.module.css';

const CalculateForm = ({
  control,
  calculate,
  submitInProgress,
  isEditable,
  onSubmit,
}: CalculateFormTypes) => (
  <div className={cn.productRiskScoreCalculationWrapper}>
    <div className={cn.productRiskScoreCalculation}>
      <div className={cn.productRiskScoreCalculationContent}>
        <div className={cn.productRiskScoreCalculationTitle}>
          Client risk score calculated by:
        </div>
        <div className={cn.productRiskScoreCalculationControls}>
          <div className={cn.productRiskScoreCalculationControl}>
            <Controller
              control={control}
              name="calculationType"
              defaultValue={RiskScoreCalculationType.AVG}
              render={({ field: { onChange } }) => (
                <Checkbox
                  name="average"
                  title="Average risk score"
                  onChange={() => onChange(RiskScoreCalculationType.AVG)}
                  type="radio"
                  checked={Boolean(calculate === RiskScoreCalculationType.AVG)}
                  disabled={!isEditable}
                />
              )}
            />
          </div>
          <div className={cn.productRiskScoreCalculationControl}>
            <Controller
              control={control}
              name="calculationType"
              defaultValue={RiskScoreCalculationType.MAX}
              render={({ field: { onChange } }) => (
                <Checkbox
                  name="maximum"
                  title="Maximum risk score"
                  onChange={() => onChange(RiskScoreCalculationType.MAX)}
                  type="radio"
                  checked={Boolean(calculate === RiskScoreCalculationType.MAX)}
                  disabled={!isEditable}
                />
              )}
            />
          </div>
        </div>
      </div>

      <ButtonSecondary
        type={ButtonType.SUBMIT}
        className={`button-white ${cn.productRiskScoreCalculationSubmit}`}
        text={submitInProgress ? 'Loading...' : 'Apply'}
        onClick={onSubmit}
        disabled={!isEditable}
        bold
      />
    </div>
  </div>
);

export default CalculateForm;
